import { render, staticRenderFns } from "./inspection-court-details.vue?vue&type=template&id=1a1b71e0&scoped=true&"
import script from "./inspection-court-details.vue?vue&type=script&lang=js&"
export * from "./inspection-court-details.vue?vue&type=script&lang=js&"
import style0 from "./inspection-court-details.vue?vue&type=style&index=0&id=1a1b71e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1b71e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
